// TODO: make client/server DRYer by making this an npm module

import AccessControl from 'accesscontrol'

// const Err = require('../error/Err');
import { roles, roleInherits } from './roles'

// Init/Export AccessControl instance
const ac = new AccessControl(roles);

// Apply role inheritance
roleInherits.forEach(([role, exts]) => ac.grant(role).extend(exts));

// get a permission object so we can add custom function to prototype #hacky
const permission = ac.permission({resource: 'user', role: 'superadmin', action: 'create'});

permission.constructor.prototype.deniedFields = function(object) {
	// Filter object to remove denied fields
	let remains = this.filter(object);

	// TODO: make work with nested props
	// Invert list to get list of denied fields
	return Object.keys(object).filter(function(e) {
		return this.indexOf(e) < 0;
	}, Object.keys(remains));	
}

export default ac


// WEBPACK FOOTER //
// ./src/modules/access-control/access-control.service.js